import React from 'react';
import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import AvailabilityTemplate from './staffAvailabilityTemplate_withLocations';
import { Tab, Tabs } from 'material-ui/Tabs';
import { getStaffLocationsById } from '../actions/UserActions';

class AvailabilityIndex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      staffLocationsList: [],
      selectedTabValue: null,
      applyForAllData: null,
      isDefault:true,
      isSameAvailabilityToAllLocations: props.isSameAvailabilityToAllLocations ? props.isSameAvailabilityToAllLocations : false,
      isSameAvailabilityToAllLocationslocal: props.isSameAvailabilityToAllLocations ? props.isSameAvailabilityToAllLocations : false,
    };
    this.renderLocationTabs = this.renderLocationTabs.bind(this);
    this.checkApplyForAll = this.checkApplyForAll.bind(this);
  }

  componentDidUpdate(prevProps,prevState){
    if(this.props.isSameAvailabilityToAllLocations !== prevProps.isSameAvailabilityToAllLocations ){
      this.setState({
        isSameAvailabilityToAllLocations: this.props.isSameAvailabilityToAllLocations,
        isSameAvailabilityToAllLocationslocal: this.props.isSameAvailabilityToAllLocations
      })
    }
  }

  componentWillMount() {
    this.props.getStaffLocationsById(this.props.staffId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.staffLocationsList && nextProps.staffLocationsList !== this.props.staffLocationsList) {
      let staffLocationsList = nextProps.staffLocationsList.data;
      this.setState({
        staffLocationsList,
      });
      let defaultLocationObj = (staffLocationsList || []).find((obj) => obj.isDefault);
      if (defaultLocationObj && defaultLocationObj.id) {
        this.setState({
          selectedTabValue: defaultLocationObj.id,
        });
      }
    }
  }

  setActive(tabValue,isDefault) {
    this.setState({ selectedTabValue: tabValue, isDefault});
  }

  checkApplyForAll() {

  }


  handleApplyToStaffToOffice = () => {
    this.setState({
      isSameAvailabilityToAllLocations : !this.state.isSameAvailabilityToAllLocations
    });
  }

  renderLocationTabs(listLocations) {
    var styles = {
      default_tab: {
        height: '40px',
        fontSize: '14px',
        backgroundColor: '#fff',
        color: 'rgba(0, 0, 0, 0.60)',
        border: '1px solid #ddd',
      },
      active_tab: {
        height: '37px',
        color: 'rgba(0, 0, 0, 0.80)',
        border: '1px solid #ddd',
        backgroundColor: '#fff',
      },
    };
    styles.tab = [];
    listLocations = listLocations || [];
    return listLocations.map((obj, index) => {
      styles.tab[obj.id] = styles.default_tab;
      if (obj.id === this.state.selectedTabValue) {
        styles.tab[obj.id] = styles.active_tab;
      }
      let isDefault = obj.isDefault && '(Default)';
      return (
        <Tab key={index} className="customtab" style={styles.tab[obj.id]}
          disabled={!obj.isDefault && this.state.isSameAvailabilityToAllLocationslocal ? true : false }
          onClick={(e) => this.setActive(obj.id,obj.isDefault)}
          value={obj.id}
          label={<font>{obj.value} {isDefault}</font>}>
          {/* { this.state.selectedTabValue === obj.id ?

            : null} */}
        </Tab>
      );
    });

  }

  render() {
    return (
      <div>
        <Tabs className="custom_tabs secondary_tab">
          {this.renderLocationTabs(this.state.staffLocationsList)}
        </Tabs>
        {/* <div className="row">
          <div className="col-sm-6 mt-35">
            <Field
              name={'ischeckApplyForCheckedDays'}
              label='Same time for all the checked week days'
              component={renderCheckBox}
              onChange={(input, value) => this.checkApplyForAll(input, value)}
            />
          </div>
        </div> */}
        <AvailabilityTemplate
          selectedLocationId={this.state.selectedTabValue}
          isSameAvailabilityToAllLocations={this.state.isSameAvailabilityToAllLocations}
          isSameAvailabilityToAllLocationslocal={this.state.isSameAvailabilityToAllLocationslocal}
          handleApplyToStaffToOffice={()=>this.handleApplyToStaffToOffice()}
          staffLocationsList = {this.state.staffLocationsList}
          isDefault={this.state.isDefault}
          staffId={this.props.staffId}/>
      </div>
    );
  }
}

const selector = formValueSelector('AvailabilityIndexForm');
AvailabilityIndex = reduxForm({
  form: 'AvailabilityIndexForm',
})(AvailabilityIndex);

const mapStateToProps = (state) => {
  // console.log("AvailabilityIndex mapStateToProps", state);
  let isSameAvailabilityToAllLocations;
  let sameAvailabilityArray;
  let foundItem;
  if(state.user.get_availability_template_by_id && state.user.get_availability_template_by_id.data && state.user.get_availability_template_by_id.data.sameAvailabilityToAllLocations){
    sameAvailabilityArray  = state.user.get_availability_template_by_id.data.sameAvailabilityToAllLocations
    if(sameAvailabilityArray .length > 0){
      foundItem = sameAvailabilityArray.find(item => item.isSameAvailabilityToAllLocations !== undefined);
      isSameAvailabilityToAllLocations = foundItem ? foundItem.isSameAvailabilityToAllLocations : null;
    }
  }
  return {
    isSameAvailabilityToAllLocations: isSameAvailabilityToAllLocations,
    staffLocationsList: state.user.staffLocationsList,
    ischeckApplyForCheckedDays: selector(state, 'ischeckApplyForCheckedDays'),
  };
};  

export default connect(mapStateToProps, { getStaffLocationsById })(AvailabilityIndex);



// WEBPACK FOOTER //
// ./src/modules/users/User/AvailabilityIndex.js